module.exports = function isFunction (fn) {
  return Object.prototype.toString.call(fn) === '[object Function]'
}



//////////////////
// WEBPACK FOOTER
// ./~/x-is-function/index.js
// module id = 222
// module chunks = 35783957827783 110308036455227 213720915766396